import { render, staticRenderFns } from "./A2PCallout.vue?vue&type=template&id=4828881c"
import script from "./A2PCallout.vue?vue&type=script&lang=js"
export * from "./A2PCallout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports